<div class="row form-group" [ngSwitch]="field.type">
    <div class="col-sm-5">
        <label class="col-form-label">{{field.label}}</label>
        <div class="input-group" *ngSwitchCase="'datetime-local'">
            <div class="input-group-prepend">
                <div class="input-group-text"><i class="fa fa-clock-o"></i></div>
            </div>
            <input  class="form-control pull-right datetime" type="text" value="{{value}}" />
        </div>
       
       <div class="input-group" *ngSwitchCase="'date'">
            <div class="input-group-prepend">
				<div class="input-group-text"><i class="fa fa-calendar"></i></div>
			</div>
			<input class="form-control pull-right date" type="text" value="{{field.value}}" />
        </div>
       
       <input type="text" *ngSwitchCase="'number'" value="{{field.value}}" class="form-control" readonly />
       
       <input type="text" *ngSwitchDefault value="{{field.value}}" (change)="field.change($event.target)" class="form-control" />
    </div>
</div>




// WEBPACK FOOTER //
// ./src/app/pages/change-terms-purchase/change-terms-purchase-row.component.html